module.exports = __webpack_public_path__ + "img/image16.63f32bed.jpg";